import Header from "../blocks/header";
import Dashboard from "../blocks/dashboard";
import * as React from "react";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import Copyright from "../blocks/copyright";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import {Link, useNavigate} from "react-router-dom";
import Button from "@mui/material/Button";
import {useTranslation} from "react-i18next";
import {connect} from "react-redux";
import {getViloyatUsers} from "../store/logIn";
import {useEffect, useState} from "react";

// Admin tomonidan: Viloyatlar ro'yxati
// Viloyatni tanlash → /regions/:id → main.js (o'sha viloyat kontekstida)
function Regions(props) {
    const {t} = useTranslation()
    const navigate = useNavigate()
    const [viloyatlar, setViloyatlar] = useState([])

    useEffect(() => {
        props.getViloyatUsers()
    }, [])

    useEffect(() => {
        setViloyatlar(props.viloyat_users || [])
    }, [props.viloyat_users])

    const toBack = () => navigate(-1)

    return (
        <div className="App">
            <div className={'home page'}>
                <Header/>
                <Dashboard/>
                <Box component="main" sx={{flexGrow: 1, height: '100vh', overflow: 'auto'}}>
                    <Toolbar/>
                    <div className={'main'}>
                        <Button variant="outlined" startIcon={<ChevronLeftIcon/>} onClick={toBack}>
                            {t('back')}
                        </Button>
                        <h2 className={'page-title'}>{t('viloyatlar')}</h2>
                        <div className="row">
                            {viloyatlar.length > 0 ? viloyatlar.map((item, index) => (
                                <div className="col-lg-2" key={index}>
                                    <Link to={'/regions/' + item.id}>
                                        <div className="card">
                                            <div className="card-header">
                                                <LocationOnIcon className={'icon-card'}/>
                                            </div>
                                            <div className="card-body">
                                                <h3 className={'text-center mb-0 text-uppercase'}>
                                                    {item.display_name || item.user_name}
                                                </h3>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            )) : (
                                <div className={'no-infos'}>{t('no_info')}</div>
                            )}
                        </div>
                    </div>
                    <Copyright/>
                </Box>
            </div>
        </div>
    );
}

export default connect(props => props.login, {getViloyatUsers})(Regions)